// import { useState } from "react";
// import { Button, Typography, TextField } from "@mui/material";
// import { Controller } from "react-hook-form";
// import UIPhoneNumber from "screens/UIComponents/UIPhoneNumber.jsx";
// import { isValidPhoneNumber } from "libphonenumber-js";
// import { formatToE164 } from "screens/helpers/commonHelper.js";
// import { checkVerifyOTP, startVerifyOTP } from "adapters/form.service";
// import { toast } from "react-toastify";

import { checkVerifyOTP, startVerifyOTP } from "adapters/form.service";
import { formatToE164 } from "helpers/commonHelper";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { toast } from "react-toastify";
import UIPhoneNumber from "./UIPhoneNumber";
import { Button, TextField, Typography } from "@mui/material";

export default function PhoneOtpField({
  methods,
  name,
  label = "Phone Number*",
  errors,
  setIsVerifyCode,
  enableOtp = false, //toggle OTP feature
}) {
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpCode, setOtpCode] = useState("");

  const showError = !!errors?.[name]?.message;

  const rules = {
    required: "Phone Number is required",
    validate: (value) => {
      const digits = (value || "").replace(/\D/g, "");
      if (!digits) return "Phone Number is required";
      const ok = isValidPhoneNumber(value) && !!formatToE164(value);
      return ok || "Invalid Phone Number";
    },
  };

  const currentPhone = methods.watch(name);

  const handleSendOTP = async () => {
    const e164 = formatToE164(currentPhone);
    if (!isValidPhoneNumber(currentPhone) || !e164) {
      toast.error("Enter a valid phone number before sending OTP");
      return;
    }
    try {
      setOtpLoading(true);
      const res = await startVerifyOTP({ phoneNumber: e164 });
      if (res?.data?.success) {
        toast.success("OTP sent successfully");
        setOtpSent(true);
        setOtpVerified(false);
        setOtpCode("");
      } else {
        toast.error(res?.data?.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      toast.error("Error sending OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    const e164 = formatToE164(currentPhone);
    if (!otpCode?.trim()) {
      toast.error("Enter the OTP code");
      return;
    }
    try {
      setOtpLoading(true);
      const res = await checkVerifyOTP({ phoneNumber: e164, code: otpCode.trim() });
      if (res?.data?.success) {
        toast.success("OTP verified");
        setOtpVerified(true);
        setIsVerifyCode?.(true);
      } else {
        toast.error(res?.data?.message || "Invalid OTP");
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      toast.error("Error verifying OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  if (!enableOtp) {
    return (
      <Controller
        control={methods.control}
        name={name}
        rules={rules}
        render={({ field }) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <UIPhoneNumber
              label={label}
              defaultCountry={"us"}
              fullWidth
              value={field.value ?? ""}
              onChange={(value) => field.onChange(value)}
              required
            />
            {showError && (
              <Typography color="error" variant="caption">
                {errors?.[name]?.message}
              </Typography>
            )}
          </div>
        )}
      />
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between" style={{ gap: 8 }}>
        <Controller
          control={methods.control}
          name={name}
          rules={rules}
          render={({ field }) => (
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <UIPhoneNumber
                label={label}
                defaultCountry={"us"}
                fullWidth
                value={field.value ?? ""}
                onChange={(value) => field.onChange(value)}
                required
                disabled={otpSent}
              />
              {showError && (
                <Typography color="error" variant="caption">
                  {errors?.[name]?.message}
                </Typography>
              )}
            </div>
          )}
        />
        <Button
          variant="contained"
          onClick={handleSendOTP}
          disabled={otpLoading || otpSent}
        >
          {otpLoading && !otpSent ? "Sending..." : "Send OTP"}
        </Button>
      </div>

      {otpSent && (
        <div className="d-flex align-items-center justify-content-between mt-2" style={{ gap: 8 }}>
          <TextField
            label="Enter OTP"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value)}
            fullWidth
            disabled={otpLoading || otpVerified}
            size="small"
          />
          <Button
            variant="outlined"
            onClick={handleVerifyOTP}
            disabled={otpLoading || otpVerified}
          >
            {otpLoading && !otpVerified ? "Verifying..." : "Verify OTP"}
          </Button>
        </div>
      )}
    </div>
  );
}